export const fileSize = (size) => (file) => file ? (file.size / 1024) <= size : true
export const fileExtension = (extension) => (file) => file ? (file.name.toLowerCase().split('.').pop() === extension) : true



// WEBPACK FOOTER //
// ./src/lib/validators.js